import { Block, useBlockRenderer } from '@/hooks/use-block-renderer'
import { BlockRenderer } from '@/Components/block-renderer'

export default function Toc() {
  const blocks = useBlockRenderer('toc') as Block[]
  return <BlockRenderer blocks={blocks} />
}
